import { render } from "./TestimonialsWrapper.vue?vue&type=template&id=867cf32a"
import script from "./TestimonialsWrapper.vue?vue&type=script&lang=js"
export * from "./TestimonialsWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/workix-frontend-vue/workix-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__